<script>
</script>
<template>
  <div>
    <PageAllow controller="StockOuts" action="manualSplit" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
                    v-model="options"
                    type="datetime"
                    show-radios
                    :radios="datetimeRadios"
                    deleteIcon
                    removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>

            <v-col>
              <!-- 确认拆单 -->
              <v-btn
                      v-if="
                  settings &&
                  !settings.stock_position_setting
                "
                      small
                      color="primary"
                      class="ms-1 float-end"
                      :disabled="(choiceDetails.length > 0 && stockSelected)?false:true"
                      @click.stop="
                        nextDialog = true;"

              >
                {{ $t("StockOrderOUT.manualSplit.confirm") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <!-- 仓库 -->
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                        color="primary"
                        hide-no-data
                        v-model="stockSelected"
                        :clearable="true"
                        :items="stocksItems"
                        :loading="stockLoading"
                        :search-input.sync="stockSearch"
                        item-text="Description"
                        item-value="id"
                        item-disabled="disabled"
                        :label="$t('Stock.ObjectName')"
                        return-object
                ></v-autocomplete>
<!--                <SearcherStock v-model="stockSelected" :stock-types="[0]" />-->
              </v-col>
              <!-- 商品分类 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterialCategoriesWithDescendants v-model="materialCategoriesSelected" />
              </v-col>
              <!-- 商品 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterials v-model="materialSelected" />
              </v-col>
              <!-- 客户 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherShops v-model="shopsSelected" />
              </v-col>
              <!-- 分组 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherDistrictsWithDescendants
                        v-model="districtsSelected"
                        :label="$t('Shop.shopDistrict', [$consts.shopName()])"
                />
              </v-col>
              <!-- 配送路线 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherDistributionUser
                  v-model="distributionUserSelected"
                  :stockId="stockSelected ? stockSelected.id : 0"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                        ref="stock_order_code"
                        v-model="options.stock_order_code"
                        @text="stockOutsKeyWord = $event"
                        :label="
                    $t('StockOrderOUT.stockOutsKeyword', [$consts.shopName()])
                  "
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="stock_order_details"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          v-model="choiceDetails"
          item-key="key"
          show-select
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          hide-default-footer
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>

          <template v-slot:item.stock_order_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.stock_order_code }}
            </span>
          </template>
          <template v-slot:item.material_name="{ item }">
            {{
              settings
              ? $t(
                settings
                ? settings.material_name_display_type == 4
                  ? "Material.nameWithCodeAndStandard"
                  : settings.material_name_display_type == 3
                  ? "Material.materialNameWithCodeAndStandard"
                    : settings.material_name_display_type == 2
                    ? "Material.materialNameWithCode"
                  : "Material.materialName"
                : "Material.materialName",
                [
                  item.material_code,
                  item.material_name,
                  item.standard_name,
                ]
              )
              : item.material_name
            }}
          </template>
          <template v-slot:item.price="{ item }">
            <span>
              {{ item.price | formatMoney }}
            </span>
          </template>
          <template v-slot:item.total_price="{ item }">
            <span>
              {{ item.total_price | formatMoney }}
            </span>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <!-- 输入实际出库时间 -->
    <DialogManualSplit
            v-model="nextDialog"
            @confirm="
              nextDialog = false;
              actualDate = $event;
              doManualSplit()"
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import StockOuts from "@/api/stock_outs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherDistributionUser from "@/components/plugins/SearcherDistributionUser";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants"
import DialogManualSplit from "./plugins/DialogManualSplit"
import Stocks from "@/api/stocks";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  stock_ids: null,
  category_codes: [],
  material_ids: [],
  shop_ids: [],
  district_ids: [],
  distribution_user_id: [],
  stock_order_code: "",
  type: 1,
  status: [2],
  cancel_flgs: [0],
  real_stock_flg: 1,
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherDistrictsWithDescendants,
    SearcherDistributionUser,
    SearcherShops,
    SearcherMaterials,
    SearcherMaterialCategoriesWithDescendants,
    DialogManualSplit,
    SearcherKeyword,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          replace: true,
          href:"/stocks",
        },
        {
          text:i18n.t("Nav.stockOrdersOut"),
          disabled: false,
          href: "/stock-orders-out",
        },
        {
          text:i18n.t("StockOrderOUT.manualSplit.title"),
          disabled: true,
        },
      ];
    },
    headers() {
      return [
        {
          text: i18n.t("StockOrderOUT.Fields.stock_out_code"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: i18n.t("StockOrderOUT.Fields.stock_out_obj_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "obj_name",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.category"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.material"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.price"),
          align: "start",
          sortable: false,
          value: "price",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.stock_out_order_num"),
          align: "start",
          sortable: false,
          value: "confirm_num",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.total_price"),
          align: "start",
          sortable: false,
          value: "total_price",
        },
      ];
    },
    datetimeRadios() {
      return [
        {
          key: "created",
          text: i18n.t("StockOrderOUT.Fields.created_time"),
        },
        {
          key: "actual",
          text: i18n.t("StockOrderOUT.Fields.actual_time"),
        }
      ]
    },
    stocksItems() {
      var stocks;
      if (this.stockDistrict) {
        stocks = this.stocks.filter(
                (stock) => stock.stock_district_code == this.stockDistrict.code
        );
      } else {
        stocks = this.stocks;
      }
      if (this.stockDistricts && this.stockDistricts.length > 0) {
        stocks = this.stocks.filter((e) =>
                this.stockDistricts.find((v) => v.code == e.stock_district_code)
        );
      } else {
        stocks = this.stocks;
      }
      return stocks.map((stock) => {
        const Description = stock.code + " / " + stock.name;
        const disabled = this.disabledItems
                ? this.disabledItems.find(
                        (disabledItem) => disabledItem.id == stock.id
                )
                : false;
        return Object.assign({}, stock, { Description, disabled });
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  data: () => ({
    datetimeRage: [
      new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    options: JSON.parse(
            sessionStorage.getItem("stock-orders-manual-split-options")
                    ? sessionStorage.getItem("stock-orders-manual-split-options")
                    : JSON.stringify(defaultOptions)
    ),
    stock_order_details: [],
    paging: {},
    stockSelected: null,
    stocks: [],
    stockLoading: false,
    stockSearch: "",
    materialCategoriesSelected: [],
    materialSelected: [],
    shopsSelected: [],
    districtsSelected: [],
    distributionUserSelected: null,
    confirmData: [],
    searchData: [],
    choiceDetails: [],
    nextDialog: false,
    actualDate: "",
    oldPath: "",
  }),

  methods: {
    resetSearch() {
      this.datetimeRage = [
        new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.stockSelected = null;
      this.materialCategoriesSelected = [];
      this.materialSelected = [];
      this.shopsSelected = [];
      this.districtsSelected = [];
      this.distributionUserSelected = null;
      //重置options
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      //重置搜索框
      let clearArr = [this.$refs.stock_order_code];
      clearArr.push(this.$refs.ext_code);
      clearArr.forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
      });
    },
    getStockOutsFromAPI() {
      if ( this.options.datetimeRadioSelected && this.options.datetimeRadioSelected == 'actual') {
        this.options.actual_date_from = this.options.actual_time_from
        this.options.actual_date_to = this.options.actual_time_to
      }
      this.options.real_stock_flg = 1
      StockOuts.getOutDetailsGroupMaterial(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_order_details = response.data.stock_order_details;
            this.stock_order_details.forEach((details,index) => {
              details.key = index
            })
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    getSelectedSession() {
      this.$commonUtils.loadOptions("stock-orders-manual-split", [
              "stockSelected",
              "materialCategoriesSelected",
              "materialSelected",
              "shopsSelected",
              "districtsSelected",
              "distributionUserSelected",
      ]).then(
              function (data) {
                if (data.options) {
                  this.options = data.options;
                  if (
                          typeof this.options.created_time_from != "undefined" &&
                          typeof this.options.created_time_to != "undefined"
                  )
                    this.datetimeRage = [
                      this.options.created_time_from,
                      this.options.created_time_to,
                    ];
                } else this.resetSearch();

                data.selecteds.forEach((selected) => {
                  switch (selected.key) {
                    case "stockSelected":
                      this.stockSelected = selected.value;
                      break;
                    case "materialSelected":
                      this.materialSelected = selected.value;
                      break;
                    case "materialCategoriesSelected":
                      this.materialCategoriesSelected = selected.value;
                      break;
                    case "shopsSelected":
                      this.shopsSelected = selected.value;
                      break;
                    case "districtsSelected":
                      this.districtsSelected = selected.value;
                      break;
                    case "distributionUserSelected":
                      this.distributionUserSelected = selected.value;
                      break;
                  }
                });
              }.bind(this)
      );
    },
    getOldSearch() {
      let oldSearch = JSON.parse(sessionStorage.getItem("picking-out-old-search")
              ? sessionStorage.getItem("picking-out-old-search")
              : {}
      )
      this.stockSelected = oldSearch.stock_id;
      this.materialCategoriesSelected = oldSearch.category_codes;
      this.materialSelected = oldSearch.material_ids;
      this.shopsSelected = oldSearch.shop_ids;
      this.districtsSelected = oldSearch.district_ids;
      this.options.stock_order_code = oldSearch.options.stock_order_code
      this.oldPath = oldSearch.old_path
      this.options.datetimeRadioSelected = oldSearch.options.datetimeRadioSelected
      this.options.created_time_from = oldSearch.options.created_time_from
      this.options.created_time_to = oldSearch.options.created_time_to
      this.options.actual_time_from = oldSearch.options.actual_time_from
      this.options.actual_time_to = oldSearch.options.actual_time_to

      sessionStorage.setItem(
              "stock-orders-manual-split-options",
              JSON.stringify(this.options)
      );
      sessionStorage.setItem(
              "stock-orders-manual-split-stockSelected",
              JSON.stringify(this.stockSelected)
      );
      sessionStorage.setItem(
              "stock-orders-manual-split-materialCategoriesSelected",
              JSON.stringify(this.materialCategoriesSelected)
      );
      sessionStorage.setItem(
              "stock-orders-manual-split-materialSelected",
              JSON.stringify(this.materialSelected)
      );
      sessionStorage.setItem(
              "stock-orders-manual-split-shopsSelected",
              JSON.stringify(this.shopsSelected)
      );
      sessionStorage.setItem(
              "stock-orders-manual-split-districtsSelected",
              JSON.stringify(this.districtsSelected)
      );
    },
    doManualSplit() {
      let split_details = this.choiceDetails.map((detail)=>{
        return {
          stock_order_code: detail.stock_order_code,
          material_id: detail.material_id,
          price: detail.price
        }
      })
      StockOuts.manualSplit({
        actual_date: this.actualDate,
        split_details: split_details
      }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$snackbar.success(i18n.t("StockOrderOUT.Messages.manualSplitSuccess"));
                  this.$router.push('/' + this.oldPath)
                }
              }.bind(this))
    },
    getStockList() {
      Stocks.fetchAllForSelect({ types: [0], status: 1 })
              .then(
                      function (response) {
                        if (response.data.status.isOK()) {
                          this.stocks = response.data.stocks;
                          let idList = this.stocks.map((detail) => {
                            return detail.id
                          })
                          if (!idList.includes(this.options.stock_ids)) {
                            this.stockSelected = null
                          }
                        }
                        this.stockLoading = false;
                      }.bind(this)
              )
              .catch(
                      function () {
                        this.stockLoading = false;
                      }.bind(this)
              );
    }
  },

  mounted() {
    this.getStockList()
    this.getOldSearch()
    this.getSelectedSession()
  },

  watch: {
    $route() {
      //   if (!this.$route.query.stock_id) {
      //     this.currentItemMode = null;
      //     this.currentItem = null;
      //   }
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.choiceDetails = [];
        this.getStockOutsFromAPI();
        sessionStorage.setItem("stock-orders-manual-split-options", JSON.stringify(this.options));
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
    // 仓库
    stockSelected: {
      handler() {
        this.options.stock_ids = this.stockSelected
                ? this.stockSelected.id
                : "";
        this.searchData.stockName = this.stockSelected
                ? this.stockSelected.Description
                : "";
        sessionStorage.setItem(
                "stock-orders-manual-split-stockSelected",
                JSON.stringify(this.stockSelected)
        );
      },
    },
    // 商品分类
    materialCategoriesSelected: {
      handler() {
        this.options.category_codes = this.materialCategoriesSelected
                ? this.materialCategoriesSelected.map((e) => {
                  return e.code;
                })
                : "";
        sessionStorage.setItem(
                "stock-orders-manual-split-materialCategoriesSelected",
                JSON.stringify(this.materialCategoriesSelected)
        );
      },
    },
    // 商品
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "stock-orders-manual-split-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    // 客户选择
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
                ? this.shopsSelected.map((alliance) => {
                  return alliance.id;
                })
                : "";
        sessionStorage.setItem(
                "stock-orders-manual-split-shopsSelected",
                JSON.stringify(this.shopsSelected)
        );
      },
    },
    // 分组查询
    districtsSelected: {
      handler() {
        this.options.district_ids = this.districtsSelected
                ? this.districtsSelected.map((e) => {
                  return e.id;
                })
                : "";
        sessionStorage.setItem(
                "stock-orders-manual-split-districtsSelected",
                JSON.stringify(this.districtsSelected)
        );
      },
    },
    // 配送路线
    distributionUserSelected: {
      handler() {
          this.options.distribution_user_id = this.distributionUserSelected
            ? this.distributionUserSelected.id
            : null;
        this.searchData.distribution = this.distributionUserSelected
                ? this.distributionUserSelected.name
                : null;
          sessionStorage.setItem(
            "stock-orders-manual-split-distributionUserSelected",
            JSON.stringify(this.distributionUserSelected)
          );
      },
    },
  },
};
</script>